const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Napravite izbor",
  seeAll: "Pogledajte sve",
  clear: "Očistite",
  back: "Natrag",
  save: "Spremite",
  close: "Zatvorite",
  of: "Od",
  to: "Do",
  copyrights: "© {date} Bridgestone Solutions. Sva prava pridržana.",
  pageNotFound: "Stranica nije pronađena",
  accessDenied: "Pristup odbijen",
  search: "Pretražite",
  year: "Godina",
  buttons: {
    loading: "Učitavanje...",
    export: "Izvezite",
    delete: "Obrišite",
    save: "Spremite",
    cancel: "Odustanite",
    next: "Dalje",
    back: "Natrag",
    skip: "Preskočite",
    send: "Pošaljite",
    clear: "Očistite",
    close: "Zatvorite",
    readNow: "Pročitajte sada",
    pointsList: "Popis bodova",
    more: "Više",
    reportError: "Prijavite grešku",
    accept: "Prihvatite",
    download: "Preuzmite",
    downloadAll: "Preuzmi sve",
    selectAll: "Odaberi sve",
    deselectAll: "Poništi odabir",
    downloadSelection: "Preuzmi odabrano",
    dealerInfoDownload: "PREUZMITE",
    toTheBasket: "U košaricu",
    toOrderDelivery: "Nastavite na adresu za dostavu",
    discover: "Otkrijte",
    newAddress: "Kreirajte novu adresu za dostavu",
    selectAddressBtn: "Odaberite adresu za dostavu",
    toOrderSummary: "Na pregled narudžbe",
    placeOrder: "Obvezujuća narudžba",
    toDashboard: "Na početnu stranicu",
    newOrder: "Nova narudžba",
    userOrders: "Na vaše narudžbe",
    toSearch: "Pretražite",
    select: "Odaberite",
    moreCustomerNumbers: "+ DODAJTE VIŠE BROJEVA KUPACA",
    loadMore: "Učitajte više",
    toStaffDashboard: "Na nadzornu ploču",
    toQuiz: "Na kviz",
    vouchers: "Vaučeri",
    exchangeVoucher: "Unovčite kod vaučera",
    confirm: "Potvrdite",
    sharePoints: "Podijelite bodove",
    create: "Kreirajte",
    update: "Ažurirajte",
    toBDrive: "U B-Drive",
    preview: "Pregled",
    clickHere: "Prikaži detalje",
    setFilters: "Molimo postavite <b>najviše jedan filter po koloni</b>",
    all: "Sve",
  },
  tooltips: {
    info: "Trebate pomoć? 01 92 64 88 50 0",
  },
  confirmation: {
    header: "Potvrda potrebna",
    message: "Želite li obrisati ovaj unos?",
  },
  nav: {
    consents: "Suglasnosti",
    dashboard: "Nadzorna ploča",
    accountDashboard: "Nadzorna ploča",
    account: "Profil",
    mailbox: "Primljena pošta",
    singleMailbox: "Poruke",
    stammdaten: "Osnovni podaci",
    news_feeds: "Vijesti",
    pointsOverview: "Pregled bodova",
    rewardsOverview: "Pregled bodova",
    about: "O BS Plus",
    service_number: "Kontakt servis",
    shop: "Shop nagrada",
    salesPromotions: "Prodajne promocije",
    promotions: "Moj račun",
    shopCategory: "Shop nagrada",
    productDetails: "Detalji proizvoda",
    userOrders: "Korisničke narudžbe",
    shoppingCart: "Košarica",
    orderDelivery: "Adresa za dostavu",
    orderSummary: "Pregled narudžbe",
    orderComplete: "Narudžba završena",
    text_page: "Statička stranica",
    staff: "Nadzorna ploča servisa",
    onlineTrainings: "Online treningi",
    trainings: "Treningi",
    training: "Trening",
    trainingForm: "Obrazac za trening",
    staffVouchers: "Vaučeri",
    wholesalerVouchers: "Vaučeri",
    brochure_prices: "Cjenovnici i brošure",
    investment: "Podrska ulaganjima",
    media: "Mediji",
    medias: "Mediji",
    wholesaler: "Nadzorna ploča veletrgovca",
    contact_service: "Kontakt informacije i servis",
    productInfo: "INFORMACIJE O PROIZVODU",
    bDrive: "Slike proizvoda",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Uvjeti sudjelovanja",
    first_stop: "Bridgestone garancija na gume",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Nadzorna ploča",
    accountDashboard: "Nadzorna ploča",
    account: "Profil",
    mailbox: "Primljena pošta",
    singleMailbox: "Poruke",
    stammdaten: "Osnovni podaci",
    news_feeds: "Vijesti",
    pointsOverview: "Pregled bodova",
    rewardsOverview: "Pregled bodova",
    about: "O BS Plus",
    service_number: "Kontakt servis",
    shop: "Shop nagrada",
    salesPromotions: "Prodajne promocije",
    promotions: "Moj račun",
    shopCategory: "Shop nagrada",
    productDetails: "Detalji proizvoda",
    userOrders: "Korisničke narudžbe",
    shoppingCart: "Košarica",
    orderDelivery: "Adresa za dostavu",
    orderSummary: "Pregled narudžbe",
    orderComplete: "Narudžba završena",
    staff: "Nadzorna ploča servisa",
    onlineTrainings: "Online treningi",
    trainings: "Treningi",
    training: "Trening",
    trainingForm: "Obrazac za trening",
    staffVouchers: "Vaučeri",
    wholesalerVouchers: "Vaučeri",
    brochure_prices: "Cjenovnici i brošure",
    investment: "Podrska ulaganjima",
    media: "Mediji",
    medias: "Mediji",
    wholesaler: "Nadzorna ploča veletrgovca",
    contact_service: "Kontakt informacije i servis",
    productInfo: "INFORMACIJE O PROIZVODU",
    bDrive: "Slike proizvoda",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Uvjeti sudjelovanja",
    first_stop: "Bridgestone garancija na gume",
    payouts: "Payouts",
},
  menu: {
    account: "Profil",
    plus: 'O Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Prodajna podrška",
    mailbox: "Primljena pošta",
    about: "O BS Plus",
    trainingAndCourses: "Treningi i kursevi",
    externalTraining: "Vanjski treningi",
    productInfo: "Informacije o proizvodu",
    productBrochures: "Brošure proizvoda",
    priceLists: "Cjenovnici",
    price: "Cijena",
    complaintForm: "Obrazac za pritužbu",
    sales_support: "Prodajna podrška",
    contact_service: "Kontakt informacije i servis",
    logOut: "Odjavite se",
    news: "Vijesti",
    news_feeds: "Vijesti",
    service_number: "Kontakt servis",
    salesPromotions: "Prodajne promocije",
    shop: "Trgovina",
    onlineTrainings: "Online treningi",
    trainings: "Treningi",
    brochure_prices: "Cjenovnici i brošure",
    media: "Mediji",
    medias: "Mediji",
    stammdaten: "Osnovni podaci",
    preislisten: "Cjenovnici",
  },
  validation: {
    requiredField: "Polje obavezno",
  },
  sortBy: {
    default: "Sortirajte po",
    desc: "Sortirajte po: Najnovije",
    asc: "Sortirajte po: Najstarije",
    name: "Ime",
    date: "Datum",
    choiceBy: "Sortirajte",
  },
  month: {
    1: "siječanj",
    2: "veljača",
    3: "ožujak",
    4: "travanj",
    5: "svibanj",
    6: "lipanj",
    7: "srpanj",
    8: "kolovoz",
    9: "rujan",
    10: "listopad",
    11: "studeni",
    12: "prosinac"
  },
};


export default {
  messages,
};
